export default {
  loginIn: "LOG IN",//登录按钮
  loginOut: "LOG OUT",
  currentAccount: "Current account",
  emptyMsg: "No character found, please try another account",
  validMsg: "The most recent character:",
  goNewGame: "Start New Game",
  reLogin: "Log into another account",
  loginDig: "Log in",//弹出框登录提示
  expirationTime: "Stay signed in for 30 days",
  goto: "Go to",
  haveRoles: "Check other created characters",
  gameDes: "Introduction",
  moreGame: "More games",
  // 邮箱登录
  forgetPas:"Forgot password?",
  changePas:"Reset password",
  passwordHolder:"Enter your password",
  codeHolder:"Enter code",
  getCode:"Get verification code",
  newPasswordHolder:"Enter new password",
  newPasswordHolder2:"Confirm new password",
  newPasswordError:"Passwords don't match.",
  codeLimit:"The code should be 4-6 characters long",
  passwordLimit:"The password must be between 4 and 20 characters",
  loginSuccess:"Login successful",
  codeSend:"A verification code has been sent to your email",
  pasSendSuccess:"Password reset successful",
  // 支付弹框
  pleaseConfirm: "Please confirm",
  payType: "Payment Method",
  immediatePay: "Pay Now",
  choosePayType: "Please select payment method",
  // 导航部分
  recharge: "Recharge",
  persion: "User Center",
  myGame: "My Game",
  myOrder: "My Order",
  customer: "Service",
  hotQuestion: "FAQ",
  connectService: "Send Feedback",
  // 首页 footer
  address: "2013-2020",
  company: "YoFi Games",
  aboutOur: "About Us",
  careOur: "Follow Us",
  agreement: "Terms of Use",
  privacy: "Privacy Policy",
  // 充值页面
  game: "Game",
  gameHolder: "Please select game",
  server: "Server",
  serverHolder: "Please select server",
  role: "Character",
  roleHolder: "Please select character",
  rechargeGear: "Game Currency",
  usuallyGoods: "Daily Packs",
  limitGoods: "Limited Packs",
  jfdh:"Point exchange",
  qiandao:"Check in gift bag",
  searchGoods: "Search",
  purchase: "Purchase",
  confirmAccount: "Please confirm account",
  payconfirmHolder: "Please confirm your order",
  payContinue: "Repay",
  payOver: "Payment completed",
  goodsEmpty: "Please select one product",
  payTipMsg1: "Kindly complete payment at the new interface!",
  payTipMsg2: "Please do not close the interface before payment is completed.",
  // 我的游戏
  roleName: "Character Name",
  roleId: "Character ID",
  roleName: "Character Name",
  roleLeavel: "Character Level",
  vipLeavel: "VIP Level",
  interestedGame: "Games you might interested",
  playGame: "Start Game",
  goRecharge: "Recharge",
  // 我的订单
  dateTimeRange: "Time",
  startTime: "Start Time",
  endTime: "End Time",
  to: "to",
  nickName: "Character Name",
  goodsName: "Pack/Game currency",
  price: "Price",
  orderId: "Order No.",
  rechargeTime: "Order Date",
  orderState: "Order Status",
  paySuccess: "Completed",
  orderClose: "Cancled",
  doPay: "Pay",
  doClose: "Cancle",
  noData: "No Data",
  search: "Search",
  confirm: "OK",
  tip: "Tip",
  colseConfirm: "Are you sure you want to cancel this order?",
  colseSuccess: "Cancelled successfully",
  // 联系客服
  feedBack: "Problems with recharge and payment",
  questionTime: "Time",
  questionTimeHolder: "Please select time",
  email: "Email",
  emailHolder: "Enter email address",
  describe: "Description",
  describeHolder: "Please describe your issue",
  screenshot: "Screenshot",
  cancel: "Cancel",
  submit: "Submit",
  submitSuccess: "Submitted",
  emailNotEmpty: "E-mail cannot be empty",
  emailFormat: "Please enter a valid email address",
  desEmpty: "Description cannot be empty",
  desMore: "Description cannot exceed 255 words",
  imgTypeError: "File format not supported!",
  imgSizeError: "Image cannot exceed 3 MB!",
  // 公司介绍页面
  companyProfile: "Brief introduction",
  companyDes: "Founded in 2013, YoFi Games is a comprehensive game developer specializing in independent game R&D and publishing.",
  developmentHis: "Development",
  developmentDes1: "Since its foundation, YoFi Games has been constantly expanding, and gradually accumulating a wealth of experience in mobile game development. The company is striving to create an unprecedented perfect game experience for players.",
  developmentDes2: "Based on strong R&D capabilities, YoFi Games has been deeply involved in the independent research and development of mobile games. At the same time, the company keeps exploring and expanding in the field of game operation and publishing, actively making great games.",
  developmentDes3: "In the future, YoFi Games will continue to explore and publish more outstanding works.",
  Telephone: "Telephone",
  Fax: "Fax",
  country: "Country",
  countryHolder: "Please select country",
  countryList: [
    { countryId: 360, countryName: 'Indonesia', currency: "IDR" },
    // { countryId: 608, countryName: 'Philippines', currency: "PHP" },
    { countryId: 458, countryName: 'Malaysia', currency: "MYR" },
    { countryId: 702, countryName: 'Singapore', currency: "SGD" },
    // { countryId: 764, countryName: 'Thailand', currency: "THB" },
    // { countryId: 104, countryName: 'Myanmar', currency: "MMK" },
    // { countryId: 418, countryName: 'Laos', currency: "LAK" },
    // { countryId: 116, countryName: 'Cambodia', currency: "USD" },
    // { countryId: 626, countryName: 'East Timor', currency: "USD" }
  ]
}


// WEBPACK FOOTER //
// ./src/common/lang/en.js